<section role="region" aria-labelledby="h2Composition">
  <!-- Token: Composition -->
  <div class="sectionHeader" [ngClass]="{'hidden': !isMobile}">
    <h2 id="h2Composition">
      {{ 'k000130' | translate }}
    </h2>
  </div>
  <div>
  <div class="flex-container-row">
  <br />
  <div class="card-white margen1 flex-container-row blue-dark w-100">
    <div class="blue-dark bold text-center font-18px w-100">
      {{ 'k004387' | translate }}
      <!-- Token: Categoría New -->
    </div>
    <div class="flex-container-row w-100 grafCompisition" id="grafCat">
      <tech-loading-peq class="flex-container-row w-100" *ngIf="isLoadGrafCat">
      </tech-loading-peq>
    </div>
    <div class="flex-container-row boxLegend w-100" [innerHTML]="grafCatLegend"></div>
  </div>
  <br />
  <div class="card-white margen1 flex-container-row blue-dark w-100">
    <div class="blue-dark bold text-center font-18px w-100">
      {{ 'k000047' | translate }}
      <!-- Token: Tipo activo -->
    </div>
    <div class="flex-container-row w-100 grafCompisition" id="grafAssetType">
      <tech-loading-peq
        class="flex-container-row w-100"
        *ngIf="isLoadGrafAssetType"
      >
      </tech-loading-peq>
    </div>
    <div
      class="flex-container-row boxLegend w-100"
      [innerHTML]="grafAssetTypeLegend"
    ></div>
  </div>
  <br />
  <div class="card-white margen1 flex-container-row blue-dark w-100">
    <div class="blue-dark bold text-center font-18px w-100">
      {{ 'k000122' | translate }}
      <!-- Token: Divisa -->
    </div>
    <div class="flex-container-row w-100 grafCompisition" id="grafCurrency">
      <tech-loading-peq
        class="flex-container-row w-100"
        *ngIf="isLoadGrafCurrency"
      >
      </tech-loading-peq>
    </div>
    <div
      class="flex-container-row boxLegend w-100"
      [innerHTML]="grafCurrencyLegend"
    ></div>
  </div>
</div>
</div>
</section>